import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { BusinessPage } from "core/constants";
import { SelfServiceContext } from "core/context/self-service.context";
import { ModalAlert } from "components/common-ui";
import { PaymentsProps } from "self-service/dashboard/components/types";

const MahPaymentButton = (props: PaymentsProps) => {
    const { onClear } = props;
    const navigate = useNavigate();

    const selfServiceContext = useContext(SelfServiceContext);
    const subscriptionsStore = selfServiceContext.stores.subscriptions;
    const store = selfServiceContext.stores.amountToPay;

    let existingDialog: HTMLDialogElement | null = null;

    const loadingMessages = {
        subscriptions: "Subscriptions are still loading",
        initiating: "Initiating payment",
        redirecting: "You are being redirected to the payment gateway"
    };

    const closeExistingModal = () => {
        if (existingDialog) {
            ModalAlert.close(existingDialog);
        }
    }

    const showErrorModal = (message: string) => {
        closeExistingModal();
        existingDialog = ModalAlert.error(message);
    }

    const showLoader = (message: string) => {
        closeExistingModal();
        existingDialog = ModalAlert.loading(message);
    }

    const showWaitingToLoadModal = () => showLoader(loadingMessages.subscriptions);

    const makePayment = async () => {
        if (subscriptionsStore.isLoading) {
            showWaitingToLoadModal();
            return;
        }

        if (!store.hasAmountToPayBeenSet) {
            await selfServiceContext.managers.amountToPay.populateAsync();
        }

        onClear();
        navigate(BusinessPage.payment);
    }

    return (<button className="btn btn-primary" onClick={makePayment}>Pay Now</button>);
}

export default MahPaymentButton;
